import { useCallback } from "react";
import { useMessageToState, jsonComparer } from "./useMessageToState";
import { useDashboardContext } from "../contexts/dashboard-context";
import { useSelectedZone } from "./useSelection";

export function useZoneDepth() {
	const dashboard = useDashboardContext();
	const selectedZone = useSelectedZone();
	return useMessageToState({
		name: "useZoneDepth",
		filterMessage: (message) =>
			eXpress.core.isZoneAffected(message, selectedZone) ||
			eXpress.core.isSelectedZoneChanged(message),
		getState: useCallback(() => {
			return {
				enableForward: dashboard.canSendZoneForwardOrBackward(1, selectedZone),
				enableBackward: dashboard.canSendZoneForwardOrBackward(-1, selectedZone),
			};
		}, [dashboard, selectedZone]),
		comparer: jsonComparer,
	});
}
